import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../../utils/TestIds';
import { IntegrationSyncIcon } from '../../../../IntegrationSyncIcon';
import { Row } from '../../../../Layout';
import { Spinner } from '../../../../Spinner';
import { Tooltip } from '../../../../Tooltip';
import { WithInfoIcon } from '../../../../WithInfoIcon';
import { SPINNER_SIZE, INDICATOR_SIZE } from '../../table.constants';
import styles from './CellAdornments.module.scss';
export function CellAdornments(param) {
    let { row, column, children, pending, testId } = param;
    var _ref, _ref1;
    var _column_isPending, _column_info, _column_indicators, _column_integrations;
    const testIds = getTestIds(testId);
    if (pending === true || ((_column_isPending = column.isPending) === null || _column_isPending === void 0 ? void 0 : _column_isPending.call(column, row)) === true) {
        return /*#__PURE__*/ _jsx(Spinner, {
            size: SPINNER_SIZE,
            intent: "inherit",
            testId: testIds.pending()
        });
    }
    // WHY: a tooltip with nothing to say never opens, so an empty info string renders no icon.
    const rawInfo = (_column_info = column.info) === null || _column_info === void 0 ? void 0 : _column_info.call(column, row);
    const info = rawInfo === '' ? undefined : rawInfo;
    const indicators = (_ref = (_column_indicators = column.indicators) === null || _column_indicators === void 0 ? void 0 : _column_indicators.call(column, row)) !== null && _ref !== void 0 ? _ref : [];
    const integrations = (_ref1 = (_column_integrations = column.integrations) === null || _column_integrations === void 0 ? void 0 : _column_integrations.call(column, row)) !== null && _ref1 !== void 0 ? _ref1 : [];
    return /*#__PURE__*/ _jsxs(Row, {
        alignItems: "center",
        gap: 6,
        className: "".concat(styles.adornments, " dt-adornments"),
        children: [
            /*#__PURE__*/ _jsx(WithInfoIcon, {
                info: info !== null && info !== void 0 ? info : '',
                showInfo: info != null,
                size: "s",
                className: "".concat(styles.value, " dt-cell-slot"),
                testId: testIds.value(),
                infoTestId: testIds.info(),
                children: children
            }),
            indicators.map((indicator, index)=>{
                var _indicator_tooltip;
                return /*#__PURE__*/ _jsx(Tooltip, {
                    placement: "top",
                    title: (_indicator_tooltip = indicator.tooltip) !== null && _indicator_tooltip !== void 0 ? _indicator_tooltip : '',
                    children: /*#__PURE__*/ _jsx(Row, {
                        as: "span",
                        alignItems: "center",
                        className: styles.indicator,
                        testId: testIds.indicator(index),
                        children: /*#__PURE__*/ _jsx(indicator.icon, {
                            size: INDICATOR_SIZE
                        })
                    })
                }, index);
            }),
            integrations.length > 0 && /*#__PURE__*/ _jsx(Row, {
                alignItems: "center",
                gap: 4,
                className: styles.integrations,
                children: integrations.map((entry, index)=>{
                    var _ref;
                    var _column_integrationTooltip;
                    return /*#__PURE__*/ _jsx(Tooltip, {
                        placement: "top",
                        title: (_ref = (_column_integrationTooltip = column.integrationTooltip) === null || _column_integrationTooltip === void 0 ? void 0 : _column_integrationTooltip.call(column, entry)) !== null && _ref !== void 0 ? _ref : '',
                        children: /*#__PURE__*/ _jsx(Row, {
                            as: "span",
                            alignItems: "center",
                            children: /*#__PURE__*/ _jsx(IntegrationSyncIcon, {
                                variant: column.integrationIcon,
                                status: entry.status,
                                size: "xsmall",
                                testId: testIds.integration(index)
                            })
                        })
                    }, "".concat(entry.provider, "-").concat(index));
                })
            })
        ]
    });
}
